import { style } from "typestyle";

export const orgImage = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "32px",
});

export const emptyImage = style({
  background: "#6ED3A8",
  borderRadius: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  marginRight: "8px",
});
